import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/shared/services/http-service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms'; //imports
import { ApiUrlService } from 'src/app/shared/services/api-url.service';
import { ToastrService } from 'ngx-toastr';
import { ValidationService } from 'src/app/shared/services/validation.service';
import { CropperSettings } from 'ngx-img-cropper';
import { NgxPaginationModule } from 'ngx-pagination';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';

import { MatPaginator } from '@angular/material/paginator';


declare var Cropper: any;
@Component({
  selector: 'app-evaluation1',
  templateUrl: './evaluation1.component.html',
  styleUrls: ['./evaluation1.component.scss']
})

export class EvaluationComponent1 implements OnInit, AfterViewInit {

  editevalution: FormGroup
  editevalutionEdit: FormGroup

  submitted: boolean = false;
  id: any
  imgdata: any = ''
  userid: any;
  private cropperInstance: any;
  croppedImage: string | null = null;
  dropdownOpen = false;
  imageSelected = false
  updatecropped: string | null = null;
  imagesize = false;
  evalutionData: any[] = [];
  paginatedItems: any[] = [];

  pageSize = 6;
  currentPage = 0;
  constructor(
    private http: HttpService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private toaster: ToastrService,
    private ApiUrl: ApiUrlService,
    private validation: ValidationService,
    private route: ActivatedRoute,
    private router: Router
  ) { this.id = localStorage.getItem('user_id'); }
  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }
  ngAfterViewInit() {
    const image = document.getElementById('imageToCrop') as HTMLImageElement;
    if (image) {
      this.cropperInstance = new Cropper(image, {
        // aspectRatio:false, 
        zoomable: true,
        scalable: true,
        viewMode: 0
      });

    }
  }
  styleId: any
  async ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.styleId = params['styleId'];
      this.getEvaluationData(this.styleId)
    });
    this.editevalution = this.fb.group({
      title: ['', this.validation.msgTitle],
      content: ['', this.validation.msgBody2],
      evaluation_category_id: ['', this.validation.required]
    })
    this.userid = localStorage.getItem('user_id');
    this.editevalutionEdit = this.fb.group({
      title: ['', this.validation.msgTitle],
      content: ['', this.validation.msgBody2],
      evaluation_category_id: ['', this.validation.required]
    })
    this.getEvaluationData(this.styleId)
    this.GetEvulationcategaroy()
    this.updatePagedData();

  }
  Back_to_Evaluation_category() {
    this.router.navigate(['/evaluation-category']);

  }
  async getEvaluationData(styleId: any) {
    const result = await this.http.post(this.ApiUrl.url.evaluation, { userId: this.userid, styleId: styleId })
    this.evalutionData = result['data'] || []
    this.updatePagedData()


  }
  async submitEvaluationData() {


    try {

      this.submitted = true;
      if (this.editevalution.invalid || !this.imgdata) return
      let formData = new FormData()
      formData.append('title', this.editevalution.get('title')?.value)
      formData.append('content', this.editevalution.get('content')?.value)
      formData.append('image', this.imgdata)
      formData.append('evaluation_category_id', this.editevalution.get('evaluation_category_id')?.value)
      let result = await this.http.post(this.ApiUrl.url.evalutionadmin, formData)
      if (result['status'] == true) {
        this.editevalution.reset()
        this.modalService.dismissAll();

        this.toaster.success(result['message'])
        this.getEvaluationData(this.styleId)
        this.imgdata = ''
      }
      else {
        this.toaster.success(result['message'])
      }
    } catch (error) {
      console.log(error)
    }
  }
  onImageError(event: any) {
    event.target.src = './assets/images/02image.png'; // fallback image path
  }
  onPageChange(event: any) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.updatePagedData();
  }

  updatePagedData() {
    const startIndex = this.currentPage * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedItems = this.evalutionData.slice(startIndex, endIndex);
  }
  async updateEvalution() {
    try {
      this.submitted = true;
      if (this.editevalutionEdit.invalid) return

      let formData = new FormData()
      formData.append('title', this.editevalutionEdit.get('title')?.value)
      formData.append('content', this.editevalutionEdit.get('content')?.value)
      formData.append('id', this.id)
      formData.append('user_id', this.userid)
      formData.append('evaluation_category_id', this.editevalutionEdit.get('evaluation_category_id')?.value)
      if (this.imgdata) {
        formData.append("image", this.imgdata);
      }
      let result = await this.http.post(this.ApiUrl.url.editevalutionEdit, formData)
      if (result['status'] == true) {

        this.modalService.dismissAll();

        this.toaster.success(result['message'])
        this.getEvaluationData(this.styleId)
      }
      else {
        this.toaster.success(result['message'])
      }
    } catch (error) {
      console.log(error)
    }
  }

  dataURItoBlob(dataURI: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
  }
  modalImageUrl: string = '';

  onImageClick(content, imageUrl: string) {
    this.modalImageUrl = imageUrl;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg', centered: true });
  }

  notificationpopup(content) {
    this.editevalution.reset()
    this.editevalutionEdit.reset()
    this.croppedImage = ""
    this.updatecropped = ""
    this.imageSelected = false

    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then((result) => { }, (reason) => {
        this.modalService.dismissAll();
      })
  }

  notificationpopup2(content: any, s: any): void {
    this.updatecropped = ""
    this.croppedImage = ""
    this.imageSelected = false
    try {
      if (s?.id) {
        this.imgdata = s.image;
        this.id = s.id
        this.editevalutionEdit.patchValue({
          title: s.title,
          content: s.content,
          evaluation_category_id: s.evaluation_category_id
        });
      }

      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {

          },
          (reason) => {
            this.modalService.dismissAll();
          }
        );

    } catch (error) {
      console.error('Error in notificationpopup2:', error);
    }
  }
  open(modal) {
    this.modalService.open(modal, { ariaLabelledBy: 'modal-basic-title' })
      .result.then((result) => {

      }, (reason) => {
        console.log('Err!', reason);
      });
  }


  onFileChange(event: Event) {

    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (file) {
      const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB

      if (file.size > maxSizeInBytes) {

        this.imagesize = true
        this.imageSelected = false;
        this.imgdata = null;
        input.value = '';
        return;
      }

      this.imgdata = file;
      this.imageSelected = true;

      const reader = new FileReader();
      reader.onload = () => {
        const img = document.getElementById('imageToCrop') as HTMLImageElement;
        img.src = reader.result as string;

        img.onload = () => {
          if (this.cropperInstance) {
            this.cropperInstance.destroy();
          }

          this.cropperInstance = new Cropper(img, {
            aspectRatio: 0,
            zoomable: false,
            scalable: false,
            viewMode: 0,
            responsive: true,
            autoCropArea: 1,
            background: false
          });
        };
      };

      reader.readAsDataURL(file);
    }
  }

  cropImage() {

    if (this.cropperInstance) {
      const canvas = this.cropperInstance.getCroppedCanvas();
      this.croppedImage = canvas.toDataURL('image/png');

      this.updatecropped = this.croppedImage;

      this.imgdata = this.dataURItoBlob(this.croppedImage)


    }
  }


  async delete(s) {
    const confirmation = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this evaluation ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    });
    if (confirmation.isConfirmed) {
      s = { ...s, user_id: this.userid };
      try {
        const result = await this.http.post(this.ApiUrl.url.delete, s);
        if (result['status'] === true) {
          this.toaster.success(result['message']);
          this.getEvaluationData(this.styleId);
        } else {
          this.toaster.error(result['message']);
        }
      } catch (error) {
        console.error(error);
        this.toaster.error('An error occurred while deleting.');
      }
    }
  }
  titleOptions: any = []
  async GetEvulationcategaroy() {
    try {
      const result = await this.http.post(this.ApiUrl.url.getevalutioncategory, { user_id: this.userid });
      this.titleOptions = result['data'];


    } catch (error) {
      console.log(error);
    }
  }
}
